import React from "react";
import { FormattedMessage } from "react-intl";
import cn from "classnames";
import { useDispatch } from "react-redux";

import { IChords3Data, ITaskEditorProps } from "../../../../../../common/types";

import { setItem, hasItem } from "../../../../../cookie";
import { ICheckboxEvent } from "../../../../../types";
import { editTask } from "../../../../../store/plan/actions";
import { post } from "../../../../../actions/general";

import ScoreEditor from "../../../../Score";
import { Checkbox } from "../../../../Form";

import EditorBar, {
    FlexLeft,
    FlexRight,
    Center,
    Changer,
} from "../../../EditorBar";

import getScale from "../../Common/getScale";
import getScore from "../../Common/getScore";
import getTempo from "../../Common/getTempo";
import ChangeColor from "../../Common/ChangeColor";
import ChangeScale from "../../Common/ChangeScale";
import ChangeTempo from "../../Common/ChangeTempo";
import useExerciseEditor from "../../Common/useExerciseEditor";

import ChordInputHintModal from "./ChordInputHintModal";
import messages from "./messages";

const Chords3Editor = ({ plan, taskIndex, reload, toggleInlineEditor, publicView, inlineEditorOpen }: ITaskEditorProps) => {
    const {
        openChanger,
        playable,
        handleChangeOpen,
        setPopupRef,
        storeScore,
        changeTempo,
        setPlayable,
        exportScore,
    } = useExerciseEditor({ plan, inlineEditorOpen, taskIndex });
    const dispatch = useDispatch();

    const changeHideNotes = ({ target: { checked } }: ICheckboxEvent) => {
        dispatch(editTask({ taskIndex, changingProp: "hideNotes", val: checked }));
        dispatch(post("task-type/change-hide-notes", {
            planId: plan._id,
            index: taskIndex,
            hideNotes: checked,
        }));
        if (!toggleInlineEditor) {
            reload!();
        }
    };

    const task = plan.tasks[taskIndex];
    const data = task.data as IChords3Data;
    const forwardProps = {
        plan,
        taskIndex,
        openChanger,
        handleChangeOpen,
        setPopupRef,
    }
    return (
        <div>
            {inlineEditorOpen && (
                <ScoreEditor
                    taskType="chords3"
                    score={JSON.parse(JSON.stringify(getScore(plan, task) || {}))}
                    scale={getScale(plan, task)}
                    tempo={getTempo(plan, task)}
                    setScore={storeScore}
                    changeTempo={changeTempo}
                />
            )}
            {!publicView && (
                <EditorBar>
                    <FlexLeft>
                        {task && task.data && <ChangeScale {...forwardProps} />}
                    </FlexLeft>
                    <Center
                        disabled={(inlineEditorOpen && !playable)}
                        tooltip={!playable && inlineEditorOpen && <FormattedMessage {...messages.createChordsScoreTooltip} />}
                        onClick={() => {
                            toggleInlineEditor(!inlineEditorOpen);
                            setPlayable(true);
                            if (inlineEditorOpen) {
                                exportScore();
                            }
                            setItem("rhytNameDone", "1", 60 * 60 * 24 * 365, "/");
                        }}
                        className={cn(
                            !(inlineEditorOpen && !playable) && !hasItem("rhytNameDone") && !task.ref && "pulsate"
                        )}
                    >
                        {inlineEditorOpen ? (
                            <FormattedMessage {...messages.stopEdit} />
                        ) : (
                            <FormattedMessage {...messages.editScore} />
                        )}
                    </Center>
                    <FlexRight>
                        <Changer>
                            <Checkbox
                                dark
                                label={<FormattedMessage {...messages.hideNotes} />}
                                checked={data.hideNotes || false}
                                onChange={changeHideNotes}
                            />
                        </Changer>
                        <ChangeTempo {...forwardProps} />
                        <ChangeColor
                            {...forwardProps}
                            color={data?.color}
                        />
                    </FlexRight>
                </EditorBar>
            )}
            <ChordInputHintModal />
        </div>
    );
}

export default Chords3Editor;
